import { IState } from '../../store';

export function isAbUseExperimentGroup(
  experiments: IState['abUseExperiments'],
  experimentName: string,
  targetGroup: string,
) {
  const experiment = experiments.find(e => e.experimentName === experimentName);

  if (experiment) {
    return experiment.groupName === targetGroup;
  }

  return false;
}
